/**
 * getCookieValue read a cookie value by name
 * @param {string} name key for which to retrieve the cookie value
 * @returns string value of the specified cookie key
 */
export function getCookieValue (name) {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
}

/**
 * getAuthCookie get the newtin authentication cookie value
 * @returns string value of the newtin cookie
 */
export function getAuthCookie() {
    return getCookieValue('newtin');
}
/**
 * deleteAuthCookie delete the newtin authentication cookie client side
 */
export function deleteAuthCookie() {
    document.cookie = 'newtin=; Max-Age=0';
    let domains = document.location.hostname.split('.');
    const domainPartLength = domains.length;
    if(domainPartLength > 2) {
        let noSubdomainCookie = domains[domainPartLength-2] + '.' + domains[domainPartLength-1];
        document.cookie = 'newtin=; domain=.' + noSubdomainCookie + '; max-age=0';
    }
}
